export class User {
    _id: string;
    userId: string;
    email: string;
    password: string;
    userType: string;
    first_name: string;
    last_name: string;
    phone: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    profession: string;
    profile_picture: string;
    resumes: any;
    confirmed: boolean;
    active: boolean;
    inviteSent: Date;
    last_login: Date;
    smsOptOut: boolean;
    emailOptOut: boolean;
    deleted;
    createdAt: Date;
    updatedAt: Date;

    searchText: string; // For unified search across name/email
    userTypes: any; // For filters
    hasSearchTerms; // For filters
    dateCreatedRange; // For filters
    dateCreated; // For filters
    dateCreatedEnd; // For filters
}